export const LANG_KEYS_FAQ = ['italiano', 'inglese', 'tedesco', 'olandese', 'danese', 'polacco']

let faqClientKeySeq = 0

export function createFaqClientKey() {
  faqClientKeySeq += 1
  return `faq-client-${faqClientKeySeq}-${Date.now()}`
}

export function emptyFaqItem(ordine = 0) {
  const item = { ordine, _faqKey: createFaqClientKey() }
  LANG_KEYS_FAQ.forEach((k) => {
    item[`domanda_${k}`] = ''
    item[`risposta_${k}`] = ''
  })
  return item
}

export function normalizeFaqItem(row) {
  const ordine = row?.ordine ?? 0
  const item = {
    ordine,
    _faqKey: row?._faqKey ?? (row?.id != null ? `faq-id-${row.id}` : createFaqClientKey()),
  }
  if (row?.id != null) item.id = row.id
  LANG_KEYS_FAQ.forEach((k) => {
    item[`domanda_${k}`] = ''
    item[`risposta_${k}`] = ''
  })

  LANG_KEYS_FAQ.forEach((k) => {
    item[`domanda_${k}`] = row?.[`domanda_${k}`] ?? ''
    item[`risposta_${k}`] = row?.[`risposta_${k}`] ?? ''
  })
  return item
}

/** API/editor list: empty DB → empty array (no placeholder row). */
export function normalizeFaqList(faq) {
  if (!faq || !Array.isArray(faq) || faq.length === 0) return []
  return faq.map((row, i) => normalizeFaqItem({ ...row, ordine: i }))
}

export function applyFaqApiResponse(data) {
  if (!data) return { faq_abilitato: false, faq: [] }
  return {
    faq_abilitato: Boolean(data.faq_abilitato),
    faq: normalizeFaqList(data.faq),
  }
}

export function isFaqListEffectivelyEmpty(faqList) {
  if (!faqList?.length) return true
  return faqList.every((item) =>
    LANG_KEYS_FAQ.every((k) => {
      const d = String(item[`domanda_${k}`] ?? '').trim()
      const r = String(item[`risposta_${k}`] ?? '').trim()
      return !d && !r
    })
  )
}

function faqItemForPersist(item, ordine) {
  const row = normalizeFaqItem({ ...item, ordine })
  const out = { ordine: row.ordine }
  LANG_KEYS_FAQ.forEach((k) => {
    out[`domanda_${k}`] = row[`domanda_${k}`]
    out[`risposta_${k}`] = row[`risposta_${k}`]
  })
  return out
}

export function prepareFaqForPersist(faqAbilitato, faqList) {
  if (isFaqListEffectivelyEmpty(faqList)) {
    return { faq_abilitato: Boolean(faqAbilitato), faq: [] }
  }
  const faq = faqList.map((it, i) => faqItemForPersist(it, i))
  return { faq_abilitato: Boolean(faqAbilitato), faq }
}

export function removeFaqAtIndex(faqList, index) {
  if (!Array.isArray(faqList)) return []
  return faqList
    .filter((_, i) => i !== index)
    .map((it, i) => normalizeFaqItem({ ...(it && typeof it === 'object' ? it : {}), ordine: i }))
}

/**
 * Shared FAQ list handlers for pages that own faqList / faqAbilitato state.
 * @param {{ setFaqList: Function, setFaqAbilitato: (boolean) => void, onDirty?: () => void }} options
 */
export function createFaqListHandlers({ setFaqList, setFaqAbilitato, onDirty }) {
  const markDirty = () => onDirty?.()

  return {
    cambiaFaqAbilitato: (e) => {
      setFaqAbilitato(e.target.checked)
      markDirty()
    },
    cambiaFaqItem: (index, field, value) => {
      setFaqList((prev) =>
        prev.map((it, i) =>
          i === index ? normalizeFaqItem({ ...it, [field]: value, ordine: i }) : it
        )
      )
      markDirty()
    },
    aggiungiFaqItem: () => {
      setFaqList((prev) => [...prev, emptyFaqItem(prev.length)])
      markDirty()
    },
    rimuoviFaqItem: (index) => {
      setFaqList((prev) => removeFaqAtIndex(prev, index))
      markDirty()
    },
    trimFaqListToLength: (targetLength) => {
      setFaqList((prev) => {
        if (!Array.isArray(prev) || targetLength >= prev.length) return prev
        return prev.slice(0, targetLength).map((it, i) => normalizeFaqItem({ ...it, ordine: i }))
      })
      markDirty()
    },
  }
}
